import { useLocation, useNavigate } from 'react-router-dom'
import PrimaryButton from '../../../global/components/buttons/primary-button/PrimaryButton'
import SecondaryButton from '../../../global/components/buttons/secondary-button/SecondaryButton'
import { VAN_TAB_NAMES, VAN_TAB_PATHS } from '../../../global/constants/van'
import styles from './styles.module.css'

const TABS = [
  {
    name: VAN_TAB_NAMES.vans,
    path: VAN_TAB_PATHS.vans,
  },
  {
    name: VAN_TAB_NAMES.missionCapable,
    path: VAN_TAB_PATHS.missionCapable,
  },
]

function VansTabChooser() {
  const activePath = useLocation().pathname
  const navigate = useNavigate()

  // /vans and /vans/:id should both highlight the Vans tab
  const isVansTab =
    activePath === '/vans' || (activePath.startsWith('/vans/') && !TABS.some((t) => t.path === activePath))

  return (
    <div className={styles.buttonsHolder}>
      {TABS.map((tab, idx) => {
        const isActive =
          tab.path === activePath || (tab.path === '/vans' && isVansTab)

        const ButtonComponent = isActive ? PrimaryButton : SecondaryButton

        return (
          <ButtonComponent
            key={idx}
            buttonName={tab.name}
            onClick={() => navigate(tab.path)}
            style={{ width: 'max-content', height: 'max-content' }}
          />
        )
      })}
    </div>
  )
}

export default VansTabChooser
